module.exports = __webpack_public_path__ + "img/mmi-volunteers-image-banner-paulette.1ffe176d.png";